import { EmptyState, PageHeader } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';

export const PlaceholderPage = ({ titleKey }: { titleKey: string }) => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader
        title={t(titleKey)}
        breadcrumbs={[{ label: t('nav.dashboard'), href: '/' }, { label: t(titleKey) }]}
      />
      <EmptyState title={t(titleKey)} description={t('placeholder.comingSoon')} />
    </>
  );
};
